import React, { Fragment, useEffect } from 'react'

import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Provider, useSelector } from 'react-redux'
import { Auth } from 'store/actions/auth'
import routes from 'routes'

import store from './store'
import logo from './logo.svg'
import { PrivateRoute } from 'components/wrappers/PrivateRoute'

import ViewIssues from 'views/Issues'
import EmailVerificationPage from 'views/Verification/Email'
import PageNotFound from 'views/PageNotFound'
import ResetPassword from 'views/ResetPassword'
import ForgotPassword from 'views/ForgotPassword'
import IssueDetailPage from 'views/IssueDetails'
import TechnologyBrowser from 'views/TechnologyBrowser'
import Dashboard from 'views/Dashboard'
import SignupPage from 'views/Signup'
import Profile from 'views/Profile'
import Search from 'views/Search'
import EntityDetails from 'views/EntityDetails'
import UserCollectionsPage from './views/UserCollections'
import UCollectionsPage from './views/UCollections'
import CollectionPage from './views/Collections'
import CollectionSettingsPage from './views/Collections/settings'
import CollectionSchedulePage from './views/Collections/schedule'
import CollectionExportsPage from './views/Collections/export'
import UserTeamsPage from './views/UserTeams'
// import Integrations from './views/Integrations'
import ResourcesPage from 'views/Resources'
import NavigationWrapper from 'components/wrappers/NavigationWrapper'
import FloatingUpArrowBtn from 'components/common/FloatingUpArrowBtn'
import Sidebar from 'components/Sidebar'

import './App.css'
import './tailwind/main.css'
import './styles/common.scss'
import 'rodal/lib/rodal.css'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const App = () => {
    const innerHeight = window.innerHeight

    useEffect(() => {
        const token = localStorage.getItem('access_token')
        if (token) {
            store.dispatch({ type: 'AUTHENTICATED', payload: { token } })
        } else {
            store.dispatch({ type: 'UNAUTH_USER' })
        }
    }, [])

    return (
        <Fragment>
            <Provider store={store}>
                <BrowserRouter>
                    <div className="w-full flex flex-wrap">
                        <div
                            className="bg-neutral-gray-100"
                            style={{ width: '290px' }}
                        >
                            <FloatingUpArrowBtn />
                            <ToastContainer
                                // containerId="toast-list-view-session"
                                position="top-right"
                                autoClose={3000}
                                hideProgressBar
                                newestOnTop={false}
                                limit={1}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                            <Sidebar />
                        </div>
                        <div className="mt-12 ml-6 lg:w-9/12 root">
                            <Switch>
                                <Route
                                    exact
                                    path={routes.issues}
                                    component={ViewIssues}
                                />
                                <Route
                                    exact
                                    path={'/'}
                                    component={ViewIssues}
                                />

                                <Route
                                    exact
                                    path={routes.technologies}
                                    component={TechnologyBrowser}
                                />

                                <Route
                                    exact
                                    path={routes.signup}
                                    component={SignupPage}
                                />
                                <Route
                                    exact
                                    path={routes.resetpassword}
                                    component={ResetPassword}
                                />
                                <Route
                                    exact
                                    path={routes.forgotpassword}
                                    component={ForgotPassword}
                                />
                                <Route
                                    exact
                                    path={'/auth/verify/success'}
                                    component={EmailVerificationPage}
                                />
                                <Route
                                    exact
                                    path={routes.issuedetails}
                                    component={IssueDetailPage}
                                />

                                {/* <Route
                                exact
                                path={routes.integrations}
                                component={Integrations}
                            /> */}
                                <PrivateRoute
                                    exact
                                    path={routes.user_collections}
                                    component={UCollectionsPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.collections}
                                    component={CollectionPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.collection_settings}
                                    component={CollectionSettingsPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.collection_schedule}
                                    component={CollectionSchedulePage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.collection_exports}
                                    component={CollectionExportsPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.dashboard}
                                    component={Dashboard}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.resources}
                                    component={ResourcesPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.entity_details}
                                    component={EntityDetails}
                                />

                                <PrivateRoute
                                    exact
                                    path={routes.search}
                                    component={Search}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.user_teams}
                                    component={UserTeamsPage}
                                />
                                <PrivateRoute
                                    exact
                                    path={routes.profile}
                                    component={Profile}
                                />
                                <Route component={PageNotFound} />
                            </Switch>
                        </div>
                    </div>
                </BrowserRouter>
            </Provider>
        </Fragment>
    )
}

export default App
